@use '~/theme/theme' as *;

.card {
  border: border(grey-300, sm);

  @include border-radius(sm);

  padding: spacing(2);
}

.cardActions {
  flex-shrink: 0;
}

.amount {
  text-align: right;
}

.radioCard {
  border: border(grey-300, sm);

  @include border-radius(sm);

  display: flex;
  align-items: center;
  gap: spacing(1);
  padding: spacing(2);
  width: 100%;
  cursor: pointer;

  &[data-selected],
  &[data-selected='true'] {
    background-color: color(violet-100);
  }
}

.listBoxCard {
  outline: none;

  &[data-focus-visible] .listBoxIndicator {
    outline: 2px solid color(violet-600);
    outline-offset: 2px;
  }

  &[data-hovered] .listBoxIndicatorContainer {
    background: color(violet-200);
    outline: 4px solid color(violet-200);
  }

  &[data-selected] .listBoxIndicator,
  &[data-selected='true'] .listBoxIndicator {
    border-width: 5px;
  }
}

.listBoxIndicatorContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 10px;
  width: 20px;
  height: 20px;
  transition:
    background-color 300ms,
    outline-color 300ms;
}

.listBoxIndicator {
  border: 2px color(grey-800) solid;
  border-radius: 10px;
  background: white;
  width: 20px;
  height: 20px;
  transition: border-width 300ms;
}

.compactCard {
  min-height: 82px;
  align-items: center;
}

.content {
  margin-left: spacing(1);
  flex: 1;
  width: 100%;
}

.amountWithIcon {
  display: flex;
  align-items: center;
  gap: spacing(1);
  text-align: right;
}

.trendUp {
  width: 16px;
  height: 16px;
  color: color(green-600);
}

.trendDown {
  width: 16px;
  height: 16px;
  color: color(lobster-700);
}

.flowsList {
  display: flex;
  flex-flow: column wrap;
  gap: spacing(0.25);
}
